import {treeBuild, logError} from "../function.js";


// export const  cat=


export const cat = new jqueryts.TreeCollection({
    url: () => {
        try {
            let subgroup_data = window.subgroup.map(el => {
                if (el.pid == 3) el.pid = null
                return {
                    id: el.id_cat,
                    pid: el.pid,
                    allow: el.allow,
                    link: el.link,
                    name: el.name,
                    files_sort: el.files_sort,
                    open: true,
                    sort: el.sort,
                    data: []
                }
            })
            const tree = treeBuild(subgroup_data, "id", "pid")
            return tree
        } catch (e) {
            logError(e)
        }
    },
})


export const files = new jqueryts.DataCollection({
    url: () => {
        try {
            let res = window.subgroup_file
            res = res.map(el => {
                el.id = el.id_file
                return el
            })

            return res
        } catch (e) {
            logError(e)
        }
    }
})
